import React, { useEffect } from "react";

const notifications = [
  {
    id: 1,
    message: "Live session starting in 15 min",
    time: "Just Now",
  },
  {
    id: 2,
    message: "Assignment deadline tomorrow",
    time: "2 hour ago",
  },
  {
    id: 3,
    message: "Feedback received on Assignment 2",
    time: "3 hour ago",
  },
  {
    id: 4,
    message: "New course material available",
    time: "yesterday",
  },
  {
    id: 5,
    message: "Live session starting in 15 min",
    time: "Just Now",
  },
  {
    id: 6,
    message: "Assignment deadline tomorrow",
    time: "2 hour ago",
  },
  {
    id: 7,
    message: "Feedback received on Assignment 2",
    time: "3 hour ago",
  },
  {
    id: 8,
    message: "New course material available",
    time: "yesterday",
  },
];

const NotificationsPanel = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  return (
    <>
      <div
        className={`fixed inset-0 z-[60] bg-black/30 transition-opacity duration-300 ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed right-0 top-0 z-[70] flex h-screen w-full max-w-[789px] flex-col bg-[#F5F5F5] shadow-[-8px_0_24px_rgba(0,0,0,0.12)] transition-transform duration-300 ease-in-out ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="pt-16 pl-14 pr-10"
        >
          <h2 className="text-4xl  leading-6 font-medium text-black">
            Notifications
          </h2>
          </div>
       

        <div className="flex-1 overflow-y-auto mt-[22px] ">
          <div className="divide-y divide-[#938A96] border-b border-[#938A96] ">
            {notifications.map((notification) => (
              <div
                key={notification.id}
                className="flex items-start justify-between gap-6 py-6 pl-14 pr-10"
              >
                <p className="text-xl text-black leading-[22px]">
                  {notification.message}
                </p>
                <span className="shrink-0 text-xl text-[#938A96] leading-[22px]">
                  {notification.time}
                </span>
              </div>
            ))}
          </div>
        </div>
       
      </aside>
    </>
  );
};

export default NotificationsPanel;
